import axios from 'axios';
import store from 'store';

const state = {
  users: {},
};

const getters = {
  getUsersFiltered: st => query => {
    axios.get(`clusters/users?${query}`).then(res => {
      st.users = res.data;
    });
  },
};

const mutations = {
  setUsers: (st, payload) => {
    st.users = payload;
  },
};

const actions = {
  getUsers: ({ commit }) => {
    commit('setUsers', {});
    if (store.get('permissions').indexOf('clusters.users.index') >= 0) {
      axios.get(`clusters/users`).then(res => commit('setUsers', res.data));
    }
  },
  removeUser: id => {
    if (store.get('dispatchUser').id === id) return false;
    return new Promise((resolve, reject) => {
      axios
        .delete(`clusters/users/${id}`)
        .then(() => resolve())
        .catch(err => reject(err));
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js